
export const SET_USER = "SET_USER";
export const SET_USER_START="SET_USER_START";
export const SET_ROLE = "SET_ROLE";
export const SET_AUTH = "SET_AUTH";
export const LOGOUT = "LOGOUT";

export const GET_TIMECARD = "GET_TIMECARD";
export const GET_TIMECARD_START = "GET_TIMECARD_START";
export const GET_TIMECARD_FAIL = "GET_TIMECARD_FAIL";

export const REJECT_VALIDATION = "REJECT_VALIDATION";
export const REJECT_VALIDATION_LOADING = "REJECT_VALIDATION_LOADING";
export const REJECT_VALIDATION_FAIL = "REJECT_VALIDATION_FAIL";


// export const POST_TIMECARD_REJECT = "POST_TIMECARD_REJECT";
// export const POST_TIMECARD_REJECT_LOADING = "POST_TIMECARD_REJECT_LOADING";
// export const POST_TIMECARD_REJECT_FAIL = "POST_TIMECARD_REJECT_FAIL";




export const GET_IMAGE_START = "GET_IMAGE_START";
export const GET_IMAGE = "GET_IMAGE";
export const GET_IMAGE_FAIL = "GET_IMAGE_FAIL";







export const GET_IPADDRESS_START = "GET_IPADDRESS_START";
export const GET_IPADDRESS = "GET_IPADDRESS";
export const GET_IPADDRESS_FAIL = "GET_IPADDRESS_FAIL";

export const APPROVE_TIMECARD_LOADING = "APPROVE_TIMECARD_LOADING";
export const APPROVE_TIMECARD = "APPROVE_TIMECARD";
export const APPROVE_TIMECARD_FAIL = "APPROVE_TIMECARD_FAIL";

export const APPROVE_ALL_TIMECARDS_LOADING = "APPROVE_ALL_TIMECARDS_LOADING";
export const APPROVE_ALL_TIMECARDS = "APPROVE_ALL_TIMECARDS";
export const APPROVE_ALL_TIMECARDS_FAIL = "APPROVE_ALL_TIMECARDS_FAIL";

export const APPROVE_ALL_WITHOUT_EMAIL_LOADING = "APPROVE_ALL_WITH_EMAIL_LOADING";
export const APPROVE_ALL_WITHOUT_EMAIL = "APPROVE_ALL_WITH_EMAIL";
export const APPROVE_ALL_WITHOUT_EMAIL_FAIL = "APPROVE_ALL_WITH_EMAIL_FAIL";

export const REJECT_TIMECARD_LOADING = "REJECT_TIMECARD_LOADING";
export const REJECT_TIMECARD = "REJECT_TIMECARD";
export const REJECT_TIMECARD_FAIL = "REJECT_TIMECARD_FAIL";

export const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
export const API_SERVER_PORT = process.env.REACT_APP_API_SERVER_PORT;
export const API_SERVER_TTSSERVICE = process.env.REACT_APP_API_SERVER_TTSSERVICE;


export const GET_EMPLOYEE_DETAILS = "GET_EMPLOYEE_DETAILS";
export const GET_EMPLOYEE_DETAILS_START = "GET_EMPLOYEE_DETAILS_START";
export const GET_EMPLOYEE_DETAILS_FAIL = "GET_EMPLOYEE_DETAILS_FAIL";

export const GET_CLIENT_NAMES = "GET_CLIENT_NAMES";
export const GET_CLIENT_NAMES_START = "GET_CLIENT_NAMES_START";
export const GET_CLIENT_NAMES_FAIL = "GET_CLIENT_NAMES_FAIL";

export const GET_TIMECARD_WEEKS = "GET_TIMECARD_WEEKS";
export const GET_TIMECARD_WEEKS_START = "GET_TIMECARD_WEEKS_START";
export const GET_TIMECARD_WEEKS_FAIL = "GET_TIMECARD_WEEKS_FAIL";

export const GET_JOB_NAMES = "GET_JOB_NAMES";
export const GET_JOB_NAMES_START = "GET_JOB_NAMES_START";
export const GET_JOB_NAMES_FAIL = "GET_JOB_NAMES_FAIL";

export const GET_EMPLOYEE_NAMES = "GET_EMPLOYEE_NAMES";
export const GET_EMPLOYEE_NAMES_START = "GET_EMPLOYEE_NAMES_START";
export const GET_EMPLOYEE_NAMES_FAIL = "GET_EMPLOYEE_NAMES_FAIL";

export const SAVE_FILTER_DATA = "SAVE_FILTER_DATA"

